import React from 'react'
import PropTypes from 'prop-types'
import {Tag, TagLabel} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {camelize} from 'humps'
import {ExpandableTag} from '../../ExpandableTag'

const StatusCell = ({row}) => {
  const {t} = useTranslation('pointsOnPayments')
  const status = camelize(row.original.lifecycleStatus)
  const colorScheme = {
    processing: 'neutral',
    partiallyPaid: 'neutral',
    eligible: 'success',
    ineligible: 'alert',
  }[status]

  if (status === 'ineligible' || status === 'partiallyPaid') {
    const descriptionKey =
      status === 'ineligible'
        ? 'pointsOnPayments:bill.table.columns.body.statusIneligibleDescription'
        : 'pointsOnPayments:bill.table.columns.body.statusPartiallyPaidDescription'
    return (
      <ExpandableTag
        label={t('pointsOnPayments:bill.table.columns.body.status', {
          context: status,
        })}
        colorScheme={colorScheme}
      >
        {t(descriptionKey)}
      </ExpandableTag>
    )
  }

  return (
    <Tag variant="status" colorScheme={colorScheme}>
      <TagLabel>
        {t('pointsOnPayments:bill.table.columns.body.status', {
          context: status,
        })}
      </TagLabel>
    </Tag>
  )
}

StatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      lifecycleStatus: PropTypes.string,
    }).isRequired,
  }).isRequired,
}

export default StatusCell
